import { AxiosError } from 'axios';
import { ActionType, createAction, createAsyncAction } from 'typesafe-actions';
import { MarkedToolbar } from '.';
import { Container, Contents, editorState, Email, History, ListInfo, ListVars, MergeFields, Shop } from './types';

export const GET_CONTENTS = 'emailContents/GET_CONTENTS';
export const GET_CONTENTS_SUCCESS = 'emailContents/GET_CONTENTS_SUCCESS';
export const GET_CONTENTS_ERROR = 'emailContents/GET_CONTENTS_ERROR';

export const getContentsAsync = createAsyncAction(
	GET_CONTENTS,
	GET_CONTENTS_SUCCESS,
	GET_CONTENTS_ERROR,
	)<number, Contents, AxiosError>();

export const TOGGLE_CONTENTS_TARGET_LOADING = 'emailContents/TOGGLE_CONTENTS_TARGET_LOADING';
export const toggleContentsTargetLoading = createAction(TOGGLE_CONTENTS_TARGET_LOADING)<{ target: string; isLoading: boolean}>();

export const TOGGLE_IS_CONTENTS_LOADING = 'emailContents/TOGGLE_IS_CONTENTS_LOADING';
export const toggleIsContentsLoading = createAction(TOGGLE_IS_CONTENTS_LOADING)<boolean>();

export const SWITCH_TEST_GROUP = 'emailContents/SWITCH_TEST_GROUP';
export const switchTestGroup = createAction(SWITCH_TEST_GROUP)<number>();

export const SYNC_TEST_GROUP_CONTENTS = 'emailContents/SYNC_TEST_GROUP_CONTENTS';
export const syncTestGroupContents = createAction(SYNC_TEST_GROUP_CONTENTS)<number>();

export const SET_TEST_GROUP = 'emailContents/SET_TEST_GROUP';
export const setTestGroup = createAction(SET_TEST_GROUP)<editorState['testGroup']>();

export const SET_MARKED_TOOLBAR = 'emailContents/SET_MARKED_TOOLBAR';
export const setMarkedToolbar = createAction(SET_MARKED_TOOLBAR)<MarkedToolbar>();

export const SET_EMAIL_ID = 'emailContents/SET_EMAIL_ID';
export const setEmailId = createAction(SET_EMAIL_ID)<number>();

export const GET_EMAIL = 'emailContents/GET_EMAIL';
export const GET_EMAIL_SUCCESS = 'emailContents/GET_EMAIL_SUCCESS';
export const GET_EMAIL_ERROR = 'emailContents/GET_EMAIL_ERROR';

export const getEmailAsync = createAsyncAction(
	GET_EMAIL,
	GET_EMAIL_SUCCESS,
	GET_EMAIL_ERROR,
)<number, Email, AxiosError>();

export const GET_CONTAINER = 'emailContents/GET_CONTAINER';
export const GET_CONTAINER_SUCCESS = 'emailContents/GET_CONTAINER_SUCCESS';
export const GET_CONTAINER_ERROR = 'emailContents/GET_CONTAINER_ERROR';

export const getContainerAsync = createAsyncAction(
	'emailContents/GET_CONTAINER',
	'emailContents/GET_CONTAINER_SUCCESS',
	'emailContents/GET_CONTAINER_ERROR',
)<number, Container, AxiosError>();

export const GET_SYSTEMFIELDS = 'emailContents/GET_SYSTEMFIELDS';
export const GET_SYSTEMFIELDS_SUCCESS = 'emailContents/GET_SYSTEMFIELDS_SUCCESS';
export const GET_SYSTEMFIELDS_ERROR = 'emailContents/GET_SYSTEMFIELDS_ERROR';
export const getSystemFieldsAsync = createAsyncAction(
	GET_SYSTEMFIELDS,
	GET_SYSTEMFIELDS_SUCCESS,
	GET_SYSTEMFIELDS_ERROR,
)<void, MergeFields, AxiosError>();

export const GET_LISTVARS = 'emailContents/GET_LISTVARS';
export const GET_LISTVARS_SUCCESS = 'emailContents/GET_LISTVARS_SUCCESS';
export const GET_LISTVARS_ERROR = 'emailContents/GET_LISTVARS_ERROR';

export const getListVarsAsync = createAsyncAction(
	'emailContents/GET_LISTVARS',
	'emailContents/GET_LISTVARS_SUCCESS',
	'emailContents/GET_LISTVARS_ERROR',
)<void, ListVars, AxiosError>();

export const GET_LISTINFO = 'emailContents/GET_LISTINFO';
export const GET_LISTINFO_SUCCESS = 'emailContents/GET_LISTINFO_SUCCESS';
export const GET_LISTINFO_ERROR = 'emailContents/GET_LISTINFO_ERROR';

export const getListInfoAsync = createAsyncAction(
	'emailContents/GET_LISTINFO',
	'emailContents/GET_LISTINFO_SUCCESS',
	'emailContents/GET_LISTINFO_ERROR',
)<void, ListInfo, AxiosError>();

export const SET_SHOPS = 'emailContents/SET_SHOPS';
export const setShops = createAction(SET_SHOPS)<Shop[]>();

export const SET_DEFAULT_SHOP = 'emailContents/SET_SHOP_INFO';
export const setDefaultShop = createAction(SET_DEFAULT_SHOP)<Shop>();

export const GET_FILESIZE = 'emailContents/GET_FILESIZE';
export const GET_FILESIZE_SUCCESS = 'emailContents/GET_FILESIZE_SUCCESS';
export const GET_FILESIZE_ERROR = 'emailContents/GET_FILESIZE_ERROR';

export const getFilesizeAsync = createAsyncAction(
	'emailContents/GET_FILESIZE',
	'emailContents/GET_FILESIZE_SUCCESS',
	'emailContents/GET_FILESIZE_ERROR',
)<number, any, AxiosError>();

export const APPLY_FILESIZE = 'emailContents/APPLY_FILESIZE';
export const applyFilesize = createAction(APPLY_FILESIZE)<number>();

export const ADD_CONTENT = 'emailContents/ADD_CONTENT';
export const addContent = createAction(ADD_CONTENT)<any>();

export const COPY_CONTENT = 'emailContents/COPY_CONTENT';
export const copyContent = createAction(COPY_CONTENT)<any>();

export const SWITCH_CONTENT = 'emailContents/SWITCH_CONTENT';
export const switchContent = createAction(SWITCH_CONTENT)<number>();

export const EDIT_CONTENT = 'emailContents/EDIT_CONTENT';
export const editContent = createAction(EDIT_CONTENT)<any>();

export const SAVE_CONTENTS = 'emailContents/SAVE_CONTENTS';
export const SAVE_CONTENTS_SUCCESS = 'emailContents/SAVE_CONTENTS_SUCCESS';
export const SAVE_CONTENTS_ERROR = 'emailContents/SAVE_CONTENTS_ERROR';

export const saveContentsAsync = createAsyncAction(
	SAVE_CONTENTS,
	SAVE_CONTENTS_SUCCESS,
	SAVE_CONTENTS_ERROR,
)<'normal' | 'outlook' | 'publish' | { renderingOption?: 'normal' | 'outlook' | 'publish'; isWebSupport?: boolean; testGroup?: 'A' | 'B' }, void, AxiosError>();

export const TOGGLE_IS_SAVING = 'emailContents/TOGGLE_IS_SAVING';
export const toggleIsSaving = createAction(TOGGLE_IS_SAVING)<boolean>();

export const TOGGLE_SHOW_HISTORY = 'emailContents/TOGGLE_SHOW_HISTORY';
export const toggleShowHistory = createAction(TOGGLE_SHOW_HISTORY)<boolean>();

export const GET_HISTORY = 'emailContents/GET_HISTORY';
export const GET_HISTORY_SUCCESS = 'emailContents/GET_HISTORY_SUCCESS';
export const GET_HISTORY_ERROR = 'emailContents/GET_HISTORY_ERROR';

export const getHistoryAsync = createAsyncAction(
	'emailContents/GET_HISTORY',
	'emailContents/GET_HISTORY_SUCCESS',
	'emailContents/GET_HISTORY_ERROR',
)<{ emailId: number, offset: number }, History, AxiosError>();

export const HISTORY_APPLY = 'emailContents/HISTORY_APPLY';
export const historyApply = createAction(HISTORY_APPLY)<any>();

export const HISTORY_SAVE = 'emailContents/HISTORY_SAVE';
export const historySave = createAction(HISTORY_SAVE)();

export const EDIT_CONTAINER = 'emailContents/EDIT_CONTAINER';
export const editContainer = createAction(EDIT_CONTAINER)<any>();

export const MOVE_CONTENT = 'emailContents/MOVE_CONTENT';
export const moveContent = createAction(MOVE_CONTENT)<any>();

export const REMOVE_CONTENT = 'emailContents/REMOVE_CONTENT';
export const removeContent = createAction(REMOVE_CONTENT)<any>();

export const SELECT_CONTENT = 'emailContents/SELECT_CONTENT';
export const selectContent = createAction(SELECT_CONTENT)<number>();

export const SAVE_CONTENTS_LOCAL = 'emailContents/SAVE_CONTENTS_LOCAL';
export const saveContentsLocal = createAction(SAVE_CONTENTS_LOCAL)<{ target; data; } | undefined>();

export const ADD_CONTENT_CANDROP = 'emailContents/ADD_CONTENT_CANDROP';
export const addContentCanDrop = createAction(ADD_CONTENT_CANDROP)<boolean>();

export const FOOTER_UPDATE = 'emailContents/FOOTER_UPDATE';
export const footerUpdate = createAction(FOOTER_UPDATE)<any>();

export const DIALOG_SHOW = 'emailContents/DIALOG_SHOW';
export const dialogShow = createAction(DIALOG_SHOW)<any>();

export const DIALOG_HIDE = 'emailContents/DIALOG_HIDE';
export const dialogHide = createAction(DIALOG_HIDE)();

export const INIT_SIDEBAR = 'emailContents/INIT_SIDEBAR';
export const initSidebar = createAction(INIT_SIDEBAR)();

export const SHOW_SIDEBAR = 'emailContents/SHOW_SIDEBAR';
export const showSidebar = createAction(SHOW_SIDEBAR)();

export const HIDE_SIDEBAR = 'emailContents/HIDE_SIDEBAR';
export const hiseSidebar = createAction(HIDE_SIDEBAR)();

export const CHANGE_SCREENMODE = 'emailContents/CHANGE_SCREENMODE';
export const changeScreenMode = createAction(CHANGE_SCREENMODE)<string>();

export const REQUEST_SAVE = 'emailContents/REQUEST_SAVE';
export const requestSave = createAction(REQUEST_SAVE)<ActionType<typeof saveContentsAsync.request>['payload']>();

export const REQUEST_OPEN_PREVIEW = 'emailContents/REQUEST_OPEN_PREVIEW';
export const requestOpenPreview = createAction(REQUEST_OPEN_PREVIEW)();

export const FINISH_LOADING_PREVIEW = 'emailContents/FINISH_LOADING_PREVIEW';
export const finishLoaidngPreview = createAction(FINISH_LOADING_PREVIEW)();

// Saved Box Actions
export const SAVE_BOX = 'emailContents/SAVE_BOX';
export const SAVE_BOX_SUCCESS = 'emailContents/SAVE_BOX_SUCCESS';
export const SAVE_BOX_ERROR = 'emailContents/SAVE_BOX_ERROR';

export const saveBoxAsync = createAsyncAction(
	SAVE_BOX,
	SAVE_BOX_SUCCESS,
	SAVE_BOX_ERROR,
)<{ contentId: number; name: string }, any, AxiosError>();

export const LOAD_SAVED_BOXES = 'emailContents/LOAD_SAVED_BOXES';
export const LOAD_SAVED_BOXES_SUCCESS = 'emailContents/LOAD_SAVED_BOXES_SUCCESS';
export const LOAD_SAVED_BOXES_ERROR = 'emailContents/LOAD_SAVED_BOXES_ERROR';

export const loadSavedBoxesAsync = createAsyncAction(
	LOAD_SAVED_BOXES,
	LOAD_SAVED_BOXES_SUCCESS,
	LOAD_SAVED_BOXES_ERROR,
)<{ offset?: number; limit?: number; isLoadMore?: boolean }, any, AxiosError>();

export const RENAME_SAVED_BOX = 'emailContents/RENAME_SAVED_BOX';
export const RENAME_SAVED_BOX_SUCCESS = 'emailContents/RENAME_SAVED_BOX_SUCCESS';
export const RENAME_SAVED_BOX_ERROR = 'emailContents/RENAME_SAVED_BOX_ERROR';

export const renameSavedBoxAsync = createAsyncAction(
	RENAME_SAVED_BOX,
	RENAME_SAVED_BOX_SUCCESS,
	RENAME_SAVED_BOX_ERROR,
)<{ id: string; name: string }, any, AxiosError>();

export const DELETE_SAVED_BOX = 'emailContents/DELETE_SAVED_BOX';
export const DELETE_SAVED_BOX_SUCCESS = 'emailContents/DELETE_SAVED_BOX_SUCCESS';
export const DELETE_SAVED_BOX_ERROR = 'emailContents/DELETE_SAVED_BOX_ERROR';

export const deleteSavedBoxAsync = createAsyncAction(
	DELETE_SAVED_BOX,
	DELETE_SAVED_BOX_SUCCESS,
	DELETE_SAVED_BOX_ERROR,
)<string, any, AxiosError>();

export const ADD_SAVED_BOX = 'emailContents/ADD_SAVED_BOX';
export const ADD_SAVED_BOX_SUCCESS = 'emailContents/ADD_SAVED_BOX_SUCCESS';
export const ADD_SAVED_BOX_ERROR = 'emailContents/ADD_SAVED_BOX_ERROR';
export const addSavedBox = createAction(ADD_SAVED_BOX)<{ seq: number; boxId: string }>();
export const addSavedBoxAsync = createAsyncAction(
	ADD_SAVED_BOX,
	ADD_SAVED_BOX_SUCCESS,
	ADD_SAVED_BOX_ERROR,
)<{ seq: number; boxId: string }, any, AxiosError>();

export const SET_AD_KEYWORD = 'emailContents/SET_AD_KEYWORD';
export const setAdKeyword = createAction(SET_AD_KEYWORD)<string>();
export const SHOW_TOKEN_WARNING = 'emailContents/SHOW_TOKEN_WARNING';
export const showTokenWarning = createAction(SHOW_TOKEN_WARNING)<string>();

export const HIDE_TOKEN_WARNING = 'emailContents/HIDE_TOKEN_WARNING';
export const hideTokenWarning = createAction(HIDE_TOKEN_WARNING)();
